<template>
  <div class="home">
    <div class="filter-wrapper filter-wrapper-tab">
      <CallsLink />
      <div class="link-filter-wrapper gifts-report__filter-wrapper">
        <div>
          <div class="date-range-picker">
            <DatePicker
              ref="dateRangePicker"
              v-model="dateRange"
              range
              type="daterange"
              format="DD MMM YYYY"
              placeholder="Start Date - End Date"
              popper-class="green-theme"
              range-separator=" — "
              :lang="{
                formatLocale: {
                  firstDayOfWeek: 1,
                }
              }"
              input-class="custom-input"
              :confirm="true"
              confirm-text="OK"
              @change="changeDateRange"
              @clear="resetToDefault">
              <template #icon-calendar>
                <font-awesome-icon :icon="dataCalendarDays" />
              </template>
            </DatePicker>
          </div>

          <v-select
            v-model="dataSelectTeamsValue"
            :options="dataSelectOptionsTeam"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Teams"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectTeamsValue ? 'call-select--value' : null,
            ]"
            @input="onSelectTeams">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Name Team
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <v-select
            v-model="dataSelectProjectsValue"
            :options="computedDataSelectOptionsProject"
            label="name"
            :disabled="!dataSelectTeamsValue"
            :components="{ Deselect: dataComponentDeselect }"
            :placeholder="'All Projects'"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectProjectsValue ? 'call-select--value' : null,
            ]"
            @input="onSelectProjects">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Name Project
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div
                :title="option.name"
                class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <v-select
            v-model="dataSelectBonusesValue"
            :options="dataSelectOptionsBonus"
            label="description"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Bonuses"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectBonusesValue ? 'call-select--value' : null,
            ]"
            @input="onSelectBonuses">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Name Bonus
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div
                :title="option.description"
                class="d-center">
                {{ option.description }}
              </div>
            </template>
          </v-select>

          <span
            style="display: flex; align-items: center;"
            class="last-update-wrapper">Upd: {{ computedLastUpdate | dateFilterUTC }}</span>
        </div>
        <div />
      </div>
    </div>
    <div class="home-mian-wr">
      <div
        class="table-wrapper table-wrapper-giftsreport"
        style="width: 50%;">
        <b-table
          :show-empty="isLoaded"
          hover
          no-local-sorting
          table-class="deposits-table"
          :fields="teamFields"
          :items="dataBonusReport"
          tbody-tr-class="row-white"
          @row-hovered="onHover"
          @row-unhovered="onUnHover">
          <template #empty>
            <EmptyTable />
          </template>
          <template #cell(team_name)="data">
            <span class="call-td call-td--bold">{{ data.item.team_name }}</span>
          </template>
          <template #cell(totalBonuses)="data">
            <span class="call-td call-tabel--right">{{ teamTotal(data.item) }}</span>
          </template>
          <template #cell(actions)="data">
            <call-table-gifts-report-actions
              :rotate="data.item._showDetails"
              expand-text="Show Projects"
              collapse-text="Hide Projects"
              @on-action="value => onActions(data, value)" />
          </template>
          <template #row-details="row">
            <b-table
              :show-empty="isLoaded"
              hover
              no-local-sorting
              table-class="deposits-subtable"
              :fields="projectFields"
              :items="
                row.item.projects.map(item => {
                  item.actions = '';
                  item._showDetails = true;
                  return item;
                })
              "
              tbody-tr-class="row-blue"
              @row-hovered="onHover"
              @row-unhovered="onUnHover">
              <template #cell(project_name)="data">
                <span class="call-td call-td--bold">{{ data.item.project_name }}</span>
              </template>
              <template #cell(totalBonuses)="data">
                <span class="call-td call-tabel--right">{{ projectTotal(data.item) }}</span>
              </template>
              <template #cell(actions)="data">
                <div class="table_actions gifts-report-project-actions">
                  <call-tooltip
                    placement="top"
                    content="View">
                    <call-button
                      outlet
                      type="success"
                      round
                      not-border
                      :icon="dataIconEye"
                      @click="onProjectView(data.item, row.item)" />
                  </call-tooltip>
                  <call-table-gifts-report-actions
                    :rotate="!!expandedProjectIds[data.item.project_id]"
                    expand-text="Show Gifts"
                    collapse-text="Hide Gifts"
                    @on-action="() => onToggleProject(data.item)" />
                </div>
              </template>
              <template #row-details="projectRow">
                <div v-if="expandedProjectIds[projectRow.item.project_id]">
                  <b-table
                    :show-empty="isLoaded"
                    hover
                    no-local-sorting
                    table-class="deposits-subtable"
                    :fields="bonusFields"
                    :items="projectRow.item.bonuses || []"
                    tbody-tr-class="row-blue">
                    <template #cell(bonus_name)="data">
                      <span class="call-td">{{ data.item.bonus_name }}</span>
                    </template>
                    <template #cell(bonus_count)="data">
                      <span class="call-td call-tabel--right">{{ data.item.bonus_count }}</span>
                    </template>
                    <template #cell(actions)>
                      <span />
                    </template>
                  </b-table>
                </div>
              </template>
            </b-table>
          </template>
        </b-table>
      </div>
      <div
        class="chart-right"
        style="width: 50%;">
        <BonusesChart
          v-if="totalAmountByDate.length"
          :formatted-range="formattedRange"
          :bonuses-by-period="totalAmountByDate"
          :bonus-labels="bonusLabelsMap"
          :data-select-chart-value-id="dataSelectChartValueId"
          @dataSelectChartValue="
            (value) => {
              dataSelectChartValueId = value.id;
              $_ajax({ reset: true });
            }
          " />
      </div>
    </div>
  </div>
</template>

<script>
import CallsLink from './components/CallsLink.vue';
import BonusesChart from './components/BonusesChart.vue';
import CallTableGiftsReportActions from '@/components/desktop/CallTableGiftsReportActions';
import CallButton from '@/components/common/CallButton';
import { BTable } from 'bootstrap-vue';
import {
  TEAMS_GET_ALL,
  BONUS_REPORT,
  BONUS_LIST,
  PROJECTS_GET_ALL
} from '../../../store/types/actions.types';
import helper from '../../../service/helper';
import {
  faEye,
  faPowerOff
} from '@fortawesome/pro-regular-svg-icons';
import selectAllTeams from '../../../mixins/select/selectAllTeams';
import giftsReportTable from '../../../mixins/table/giftsReportTable';
import moment from 'moment';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';

const defaultDate = [
  moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
];

export default {
  name: 'CallsGiftsReport',
  components: {
    CallsLink,
    BonusesChart,
    CallTableGiftsReportActions,
    CallButton,
    BTable
  },
  mixins: [
    selectAllTeams,
    giftsReportTable
  ],
  data () {
    return {
      dataCalendarDays: faCalendarDays,
      dataIconEye: faEye,
      dataIconLock: faPowerOff,
      startDate: null,
      endDate: null,
      defaultDateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      dateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      formattedRange: [defaultDate[0], defaultDate[1]],
      isLoaded: false,
      dataBonusReport: [],
      dataSelectOptionsProject: [],
      dataSelectProjectsValue: null,
      dataSelectOptionsBonus: [],
      dataSelectBonusesValue: null,
      totalAmountByDate: [],
      bonusLabelsMap: {},
      dataSelectChartValueId: 'day',
      expandedProjectIds: {},
      statRefreshedAt: ''
    };
  },

  computed: {
    computedLastUpdate () {
      return this.statRefreshedAt;
    },

    computedDataSelectOptionsProject () {
      return [...this.dataSelectOptionsProject].sort(
        (a, b) => b.is_active - a.is_active
      );
    }
  },

  async created () {
    this.$_ajax = ((options = {}) => {
      this.isLoaded = false;

      const { currentRoute: { name: pageName } = {} } = this.$router;
      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'dateRange',
            'team_ids',
            'project_ids',
            'bonus_ids'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'dateRange':
                  this.dateRange = options[_key].map((d) => new Date(d));
                  this.formattedRange = options[_key];
                  break;
                case 'team_ids':
                  this.dataSelectTeamsValue = options[_key];
                  break;
                case 'project_ids':
                  this.dataSelectProjectsValue = options[_key];
                  break;
                case 'bonus_ids':
                  this.dataSelectBonusesValue = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        dateRange = this.formattedRange,
        teamId = this.dataSelectTeamsValue,
        projectId = this.dataSelectProjectsValue,
        bonusId = this.dataSelectBonusesValue
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          const reportResponse = await this.$store.dispatch(
              `bonus/${BONUS_REPORT}`,
              helper.clearObject({
                params: {
                  start_timestamp: dateRange[0],
                  end_timestamp: dateRange[1],
                  timezone: 0,
                  team_ids: helper.clearObject([teamId?.id]),
                  project_ids: helper.clearObject([projectId?.id]),
                  bonus_ids: helper.clearObject([bonusId?.id]),
                  period_group_by: this.dataSelectChartValueId
                }
              })
          );

          const {
            payload = {},
            misc = {}
          } = reportResponse || {};

          this.statRefreshedAt = misc.stats_refreshed_at || '';

          const teams = payload.grouped_by_teams || [];
          const period = payload.grouped_by_period || [];

          this.bonusLabelsMap = {};
          teams.forEach((team) => {
            (team.projects || []).forEach((project) => {
              (project.bonuses || []).forEach((bonus) => {
                if (bonus.bonus_id != null) {
                  this.bonusLabelsMap[`bonus_${bonus.bonus_id}`] = bonus.bonus_name;
                }
              });
            });
          });

          this.dataBonusReport = teams.map((item) => {
            item.actions = false;
            item._showDetails = false;
            return item;
          });

          this.totalAmountByDate = period;
          this.expandedProjectIds = {};

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    dateRange,
                    team_ids: teamId,
                    project_ids: projectId,
                    bonus_ids: bonusId
                  })
                )
              }
            })
            .catch(() => {});

          options = {};
          this.isLoaded = true;
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    try {
      const [
        {
          payload: { list: listTeam = [] }
        }
      ] = await Promise.all([
        this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
          params: {
            short: true
          }
        }),
        this.$_ajax()
      ]);

      this.dataSelectOptionsTeam = listTeam.sort(
        (a, b) => b.is_active - a.is_active
      );

      await Promise.all([
        this.$_loadProjects({ keepSelected: true }),
        this.$_loadBonuses()
      ]);
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },

  methods: {
    teamTotal (team) {
      return (team.totals && team.totals.bonuses_count) || 0;
    },

    projectTotal (project) {
      return (project.totals && project.totals.bonuses_count) || 0;
    },

    changeDateRange () {
      if (this.$refs.dateRangePicker) {
        this.$refs.dateRangePicker.closePopup();
      }
      setTimeout(() => {
        if (this.dateRange.length === 2) {
          this.formattedRange = [
            moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
            moment(this.dateRange[1])
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          ];
          this.$_ajax();
        }
      }, 10);
    },

    resetToDefault () {
      this.dateRange = [...this.defaultDateRange];
    },

    async onSelectTeams () {
      await this.$_loadProjects();
      this.$_ajax({ reset: true });
    },

    onSelectProjects () {
      this.$_ajax({ reset: true });
    },

    onSelectBonuses () {
      this.$_ajax({ reset: true });
    },

    $_resetProjectFilter () {
      this.dataSelectProjectsValue = null;
      this.dataSelectOptionsProject = [];
    },

    async $_loadProjects ({ keepSelected = false } = {}) {
      if (!this.dataSelectTeamsValue) {
        this.$_resetProjectFilter();
        return;
      }

      if (!keepSelected) {
        this.dataSelectProjectsValue = null;
      }

      try {
        const {
          payload: { list: listProject = [] }
        } = await this.$store.dispatch(`project/${PROJECTS_GET_ALL}`, {
          params: helper.clearObject({
            team_ids: [this.dataSelectTeamsValue?.id]
          })
        });

        this.dataSelectOptionsProject = listProject;
      } catch (error) {
        console.log(error);
      }
    },

    async $_loadBonuses () {
      try {
        this.dataSelectOptionsBonus = await this.$store.dispatch(
          `bonus/${BONUS_LIST}`
        );
      } catch (error) {
        console.log(error);
      }
    },

    onHover (item) {
      this.$set(item, 'actions', true);
    },

    onUnHover (item) {
      this.$set(item, 'actions', false);
    },

    onActions (data) {
      data.toggleDetails();
    },

    onToggleProject (project) {
      const id = project.project_id;
      this.$set(this.expandedProjectIds, id, !this.expandedProjectIds[id]);
    },

    onProjectView (project, team = {}) {
      const projectName = [team?.team_name, project?.project_name]
        .filter((item) => !!item)
        .join(' | ');

      this.$router.push({
        name: 'CallsGiftsReportProject',
        params: {
          projectId: project?.project_id
        },
        query: {
          ...(this.$route.query || {}),
          projectName
        }
      });
    }
  }
};
</script>

<style lang="scss">
.table-wrapper-giftsreport {
  height: min-content;
  .gifts-report-row-hover {
    background-color: rgba(32, 160, 82, 0.05) !important;
  }
  .call-tabel-action {
    width: 80px;
    padding-right: 8px;
  }
  .table_actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button {
      margin: 0 !important;
    }
  }
  .gifts-report-project-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
  }
  .deposits-subtable {
    .call-th {
      padding: 0 !important;
    }
  }
  .gifts-report-project-name {
    padding-left: calc(0.75rem + 8px) !important;
  }
  .gifts-report-bonus-name {
    padding-left: calc(0.75rem + 16px) !important;
  }
}

.gifts-report__filter-wrapper {
  .mx-input-wrapper {
    .custom-input {
      width: 100%;
    }
  }
  .date-range-picker {
    max-width: 220px;
    display: flex;
    align-items: center;
    background: #eeeeef;
    padding-left: 8px;
    border-radius: 8px;
    margin-right: 8px;
  }

  .custom-input {
    border: none;
    background: transparent;
    font-size: 14px;
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.date-range-picker {
  max-width: 220px;
  display: flex;
  align-items: center;
  background: #eeeeef;
  padding-left: 8px;
  border-radius: 8px;
  margin-right: 8px;
}

.home-mian-wr {
  display: flex;
  gap: 32px;
  > * {
    flex: 1;
  }

  .chart-right {
    position: relative;
    .chart-card {
      top: 16px;
      left: 0;
      position: sticky;
    }
  }
}
</style>
